// extracted by mini-css-extract-plugin
export var fullHeightState = "_24-7";
export var headerCell = "_24-1";
export var loadingStateCell = "_24-4";
export var rowWrapper = "_24-3";
export var standaloneTable = "_24-8";
export var standaloneTableWithBodyFill = "_24-9";
export var stateCell = "_24-5";
export var table = "_24-0";
export var tableBodyFiller = "_24-6";
export var white = "_24-2";